import { useEffect, useState } from "react";

import { NotificationDiv } from "../SidebarNotificationsStyles";

import { format } from "date-fns";
import { ITurnConfirmation } from "./model";

interface ITurnConfirmationNotificationCard {
  notification: ITurnConfirmation;
}

const TurnConfirmationNotificationCard = (
  props: ITurnConfirmationNotificationCard
) => {
  const { notification } = props;
  const { appointment } = notification;

  const [volantes, setVolantes] = useState<string>("");

  useEffect(() => {
    const volatesSlice = appointment.volante_details
      .slice(0, 4)
      .map((v) => v.volante_num)
      .join(",");
    const volanteSilicePoint = appointment.volante_details
      .map((v) => v.volante_num)
      .join(",");
    if (appointment.volante_details.length < 4) {
      setVolantes(volanteSilicePoint);
    } else {
      setVolantes(volatesSlice);
    }
  }, [appointment]);

  return (
    <div>
      <NotificationDiv
        fontWeight={500}
        fontSize="1.1rem"
        marginTop="0.5rem"
        color="#2E353D"
        paddingLeft="1rem"
      >
        Fecha de retiro:{" "}
        <b>{format(new Date(appointment.timeslot.start), "yyyy-MM-dd")}</b>
      </NotificationDiv>
      <NotificationDiv
        fontWeight={500}
        fontSize="1.1rem"
        marginTop="0.5rem"
        color="#2E353D"
        paddingLeft="1rem"
      >
        Hora de retiro:{" "}
        <b>{format(new Date(appointment.timeslot.start), "HH:mm")}</b>
      </NotificationDiv>
      <div style={{ display: "flex" }}>
        <NotificationDiv
          fontWeight={500}
          fontSize="1.1rem"
          marginTop="0.5rem"
          color="#2E353D"
          paddingBottom="1rem"
          paddingLeft="1rem"
        >
          Nº VOLANTE{appointment.volante_details.length > 1 && "S"}:{" "}
          <b>
            {`${
              appointment.volante_details.length < 4
                ? `${volantes}`
                : `${volantes}...`
            }`}
          </b>
        </NotificationDiv>
      </div>
    </div>
  );
};

export default TurnConfirmationNotificationCard;
